import React from 'react'
import { withStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import BaseVariant from './BaseVariant';

const style = theme => ({
	root: {

	}
})

function BiggerVariant({
	classes,
	index,
	formikProps,
	isLast,
	disabled
}) {
	return (
		<BaseVariant
			index={index}
			formikProps={formikProps}
			disableMax
			isLast={isLast}
			disabled={disabled}
		/>
	)
}

BiggerVariant.propTypes = {
	classes: PropTypes.any,
}

BiggerVariant.defaultProps = {
}

export default withStyles(style)(BiggerVariant);